import LinkButton from '@atlaskit/button/new';

import { token } from '@atlaskit/tokens';

import { css } from '@compiled/react';

import { useMessageContext } from '@atlassian/post-office-context/message-context';

import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';

import { useMessageEvent } from '@post-office/message-lifecycle';

import React, { useEffect, useRef, useState } from 'react';

import { FormattedMessage } from 'react-intl';

import { createRender } from './types';

import { type JSX } from 'react/jsx-runtime';

import { registeredContent } from './content';

const containerStyles = css({
	display: 'flex',
	flexDirection: 'column',
	padding: token('space.200'),
	width: '100%',
	alignItems: 'flex-start',
	justifyContent: 'center',
	gap: token('space.100'),
	borderRadius: 8,
	backgroundColor: token('color.background.accent.blue.subtlest', '#4C9AFF'),
});

const linkButtonOverride = css({
	'[data-testid="dismiss-button"]': {
		padding: 0,
		display: 'flex',
		alignItems: 'center',
	},
});

const linkButtonTextStyles = css({
	color: token('color.text.selected'),
});

const iconStyles = css({
	padding: '12px 0',
});

const Icon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="20" viewBox="0 0 32 20" fill="none">
		<path
			d="M6.89014 7.56094V4.95694H0.196102C0.196102 7.67549 0.185411 10.3406 0.202211 13.0057C0.206792 13.835 0.237338 14.6689 0.341192 15.4905C0.747447 18.6871 3.66301 20.1869 6.28076 18.5756C6.70381 18.3145 6.90999 18.0105 6.90541 17.4668C6.87487 14.1649 6.89014 10.8629 6.89014 7.55941V7.56094Z"
			fill="#FCA700"
		/>
		<path
			d="M21.4909 15.8556L21.5138 15.8479V1.86271L21.4909 1.85355L0.19458 8.85456L21.4909 15.8556Z"
			fill="#1868DB"
		/>
		<path
			d="M29.4847 0.982542C29.2282 0.62516 29.0907 0.724433 29.3122 1.09403C29.6222 1.62247 29.9322 2.18603 30.2713 2.93898C30.3721 3.14974 30.4439 3.32538 30.5095 3.47505C30.5767 3.62472 30.6271 3.75149 30.6745 3.86909C30.7738 4.10429 30.8455 4.30894 30.9402 4.61287C31.096 5.12756 31.2533 5.83316 31.3373 6.46851C31.4259 7.10385 31.4488 7.66436 31.4519 7.88123C31.4519 7.94538 31.4549 8.00952 31.458 8.07367C31.4748 8.30276 31.4962 8.92436 31.4381 9.70327C31.4122 10.0927 31.3541 10.5204 31.2823 10.9556C31.1999 11.3894 31.1067 11.8338 30.9815 12.2508C30.8165 12.8433 30.647 13.3122 30.4988 13.6772C30.3553 14.0438 30.2285 14.3049 30.1476 14.4867C29.7398 15.3328 29.3839 15.9391 29.0128 16.5241C28.8082 16.8433 28.9258 16.9349 29.1625 16.6294C29.5916 16.075 29.9857 15.4718 30.4057 14.6089C30.5599 14.2713 30.9311 13.581 31.2518 12.5287C31.3007 12.3561 31.348 12.1836 31.3847 12.0094C31.5481 11.2611 31.6764 10.3905 31.7268 9.7048C31.7573 9.36269 31.7619 9.06639 31.7711 8.85716C31.7711 8.64792 31.7726 8.52269 31.7726 8.52269C31.7726 8.52269 31.7787 7.78043 31.6687 6.89156C31.6168 6.44712 31.5298 5.96603 31.432 5.52465C31.3312 5.08327 31.2197 4.67854 31.1235 4.38072C31.0868 4.26923 31.0548 4.16385 31.0227 4.06611C30.9876 3.96989 30.9555 3.87978 30.925 3.79425C30.8654 3.62472 30.8104 3.48269 30.7585 3.35898C30.7081 3.2368 30.6668 3.13294 30.6302 3.04283C30.5905 2.95578 30.5569 2.88247 30.5294 2.81832C30.1812 2.05163 29.8406 1.48807 29.4817 0.979488L29.4847 0.982542Z"
			fill="#101214"
		/>
		<path
			d="M27.3312 3.59262C27.1556 3.35742 27.0181 3.45669 27.1586 3.70411C27.3572 4.05844 27.5573 4.43262 27.7802 4.92898C27.9101 5.20848 27.9895 5.38564 28.0552 5.53989C28.1239 5.69415 28.1743 5.82855 28.2354 6.03015C28.3377 6.3692 28.4385 6.83655 28.4889 7.25808C28.5424 7.67808 28.553 8.04768 28.553 8.19124C28.553 8.234 28.553 8.27677 28.5576 8.318C28.5698 8.4692 28.5866 8.87851 28.55 9.3932C28.5164 9.90637 28.4141 10.5234 28.2506 11.0747C28.0307 11.8567 27.8077 12.3118 27.7008 12.5501C27.432 13.1091 27.2029 13.5107 26.9662 13.9048C26.8364 14.1186 26.9525 14.2102 27.1159 14.0101C27.4106 13.6467 27.6779 13.248 27.9589 12.6723C28.0613 12.4477 28.3209 11.9926 28.5378 11.2901C28.5698 11.1755 28.6004 11.0595 28.6248 10.9434C28.7256 10.4409 28.8066 9.86055 28.8402 9.40389C28.8768 8.94724 28.8707 8.61582 28.8707 8.61582C28.8707 8.61582 28.8753 8.12098 28.802 7.5284C28.7363 6.93429 28.5668 6.25008 28.4385 5.85451C28.3927 5.70484 28.3484 5.57502 28.3056 5.46353C28.2659 5.35051 28.2293 5.25582 28.1941 5.17335C28.1285 5.0084 28.0796 4.89691 28.0399 4.81291C27.8077 4.30128 27.5756 3.92862 27.3297 3.59415L27.3312 3.59262Z"
			fill="#101214"
		/>
		<path
			d="M25.0006 5.89119C24.8952 5.76443 24.7578 5.8637 24.828 6.00268C24.9273 6.20275 25.0312 6.40894 25.1518 6.68079C25.2923 6.98625 25.3504 7.0565 25.4176 7.27643C25.4741 7.46275 25.523 7.71934 25.5459 7.94996C25.5688 8.18057 25.5672 8.38217 25.5657 8.46006C25.5657 8.48297 25.5657 8.50588 25.5672 8.52879C25.5749 8.61126 25.5886 8.83425 25.5718 9.11374C25.5566 9.39475 25.5016 9.73075 25.4099 10.0316C25.2908 10.4593 25.1686 10.7067 25.1106 10.8365C24.964 11.142 24.8464 11.3649 24.7288 11.5894C24.6646 11.7116 24.7807 11.8017 24.8784 11.6948C25.0541 11.5009 25.2114 11.2809 25.3687 10.9587C25.4267 10.8334 25.5886 10.586 25.7123 10.1905C25.7307 10.1263 25.7475 10.0606 25.7582 9.99497C25.8024 9.70937 25.8437 9.38559 25.8605 9.12901C25.8788 8.87395 25.8788 8.68763 25.8788 8.68763C25.8788 8.68763 25.8819 8.41119 25.8406 8.07825C25.804 7.7453 25.7093 7.36348 25.6375 7.14203C25.5291 6.80908 25.4573 6.65483 25.4145 6.56014C25.2832 6.27454 25.1488 6.06835 25.0022 5.88661L25.0006 5.89119Z"
			fill="#101214"
		/>
		<path
			d="M6.89008 6.65372L0.192993 8.85452L6.88703 11.0553C6.88703 9.89001 6.89008 8.7247 6.89008 7.56092V6.65372Z"
			fill="#AE2A19"
		/>
	</svg>
);

function useContainerWidth() {
	const ref = useRef<HTMLDivElement>(null);
	const [width, setWidth] = useState(0);

	useEffect(() => {
		if (typeof window !== 'undefined' && ref.current) {
			const observer = new window.ResizeObserver((entries) => {
				for (const entry of entries) {
					if (entry.target === ref.current) {
						setWidth(entry.contentRect.width);
					}
				}
			});
			observer.observe(ref.current);
			// Set initial width
			setWidth(ref.current.offsetWidth);
			return () => observer.disconnect();
		}
		return;
	}, []);

	return [ref, width] as const;
}

export type Props = {
	onDismissed: (messageInstanceId: string) => void;
};

export const render: (renderProps: { onDismissed: () => void }) => JSX.Element | null =
	createRender(({ onDismissed }: Props) => {
		const { onClosed } = usePostOfficeUserInteractions();
		const { messageInstanceId } = useMessageContext();
		const { messageDismissed } = useMessageEvent();
		const [containerRef, containerWidth] = useContainerWidth();
		const isWide = containerWidth > 600;

		const handleDismiss = () => {
			if (messageInstanceId) {
				onDismissed(messageInstanceId);
			}

			void messageDismissed();

			// This will dispatch the event to Post Office which will record the Message as dismissed in the database.
			onClosed({
				interactionIdentifier: 'dismiss',
				additionalMetadata: { experiment: 'jfind-1645-simplify-sidebar' },
			});
		};

		return (
			<div css={containerStyles} ref={containerRef}>
				<div css={iconStyles}>
					<Icon />
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: isWide ? 'row' : 'column',
						gap: isWide ? '16px' : '8px',
						justifyContent: isWide ? 'space-between' : 'flex-start',
						width: '100%',
					}}
				>
					<span>
						<FormattedMessage
							{...registeredContent.default.body}
							values={{
								strong: (text: React.ReactNode) => <strong>{text}</strong>,
							}}
						/>
					</span>
					<div css={linkButtonOverride}>
						<LinkButton testId="dismiss-button" appearance="subtle" onClick={handleDismiss}>
							<div css={linkButtonTextStyles} style={{ marginBottom: isWide ? '11px' : '0' }}>
								<FormattedMessage {...registeredContent.default.button} />
							</div>
						</LinkButton>
					</div>
				</div>
			</div>
		);
	});

export default render;
